module.exports = __webpack_public_path__ + "img/logo_navyL.653e02a0.png";